
export { localStorageUtils } from "/codebuild/output/src2340768698/src/packages/utils/src/storage/index.ts"